import { useEffect, useState } from 'react';
import api from '../services/api';
import { getAsignaciones } from '../services/asignacionesService';

export function useAsignaciones(tipo = 'trianual') {
  const [asignaciones, setAsignaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchAsignaciones() {
      setLoading(true);
      setError(null);

      try {
        const response = await getAsignaciones(tipo);
        const items = response.data || [];
        const mappedAsignaciones = items.map((item) => ({
          id: `${item.id_asignacion_wms}-${item.id_entidad}`,
          id_asignacion_wms: item.id_asignacion_wms,
          id_entidad: item.id_entidad,
          nombre: item.nombre.trim(),
          legajo: item.legajo.trim(),
          examen: 'TRIANUAL',
          fecha: item.fecha,
        }));
        const asignacionesFiltradas = await Promise.all(
          mappedAsignaciones.map(async (asignacion) => {
            if (!asignacion.id_entidad) return asignacion;
            try {
              const resp = await api.get(
                `/api/informes/?evaluado=${asignacion.id_entidad}&estado=4`
              );
              const informes = resp.data || [];
              return informes.length > 0 ? null : asignacion;
            } catch {
              return asignacion;
            }
          })
        );

        if (isMounted) {
          setAsignaciones(asignacionesFiltradas.filter(Boolean));
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || 'No se pudieron cargar las asignaciones.');
          setAsignaciones([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchAsignaciones();

    return () => {
      isMounted = false;
    };
  }, [tipo]);

  return { asignaciones, loading, error };
}
